import React, { useState } from "react";
import "./Header.css";
import { IconPlus } from "@tabler/icons-react";
import {
  IconMailFilled,
  IconPhoneCall,
  IconMapPin,
  IconClockFilled,
  IconBrandFacebook,
  IconBrandTwitter,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconMenu2,
  IconX,
} from "@tabler/icons-react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom

const MobileMenu = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  // Close the mobile menu when clicking a link
  const handleLinkClick = () => {
    setMobileMenuOpen(false); // Close the menu
  };
  

  return (
    <div className="relative w-full xl:hidden">
      {/* Overlay */}
      <div
        className={`fixed inset-0 z-[32] h-screen w-full bg-black bg-opacity-60 transition-all duration-700 ease-in-out ${
          mobileMenuOpen ? "visible opacity-100" : "invisible opacity-0"
        }`}
        onClick={() => setMobileMenuOpen(false)}
      ></div>

      {/* Mobile Nav Bar */}
      <nav className="fixed top-0 z-[31] w-full bg-white shadow-lg xl:hidden">
        <div className="container relative flex items-center justify-between px-3 py-3 md:py-5 m-auto">
          <Link to="/">
            <img
              src="/assets/shahid.png"
              width="172"
              height="47"
              alt="logo"
            />
          </Link>
          <button
            className="cursor-pointer bg-white p-2 xl:hidden"
            onClick={() => setMobileMenuOpen(true)}
          >
            <IconMenu2 size={30} className="text-primary" />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`fixed left-0 top-0 z-[33] h-screen w-full max-w-[350px] bg-white pb-4 shadow-2xl transition-transform duration-700 ease-in-out xl:hidden ${
          mobileMenuOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        {/* Mobile Menu Header */}
        <div className="flex items-center justify-between px-6 py-4">
          <img
            src="/assets/shahid.png"
            width="172"
            height="47"
            alt="logo"
          />
          <button
            aria-label="mobile menu close"
            className="cursor-pointer text-n2"
            onClick={() => setMobileMenuOpen(false)}
          >
            <IconX size={30} className="text-primary" />
          </button>
        </div>

        {/* Mobile Menu Items */}
        <ul className="px-3">
          {[
            "Home",
            "About Us",
            "Solutions",
            "Technologies",
            "Industries",
            "Careers",
          ].map((item, index) => {
            const path =
              item === "Home"
                ? "/"
                : `/${item.replace(/\s+/g, "-").toLowerCase()}`;
            return (
              <li
                key={index}
                className="w-full"
                style={{
                  color: "#212529",
                  transition: "color 0.3s ease", // Smooth transition for hover effect
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = "rgb(0, 109, 178)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.color = "#212529")}
              >
                <Link
                  to={path}
                  className="flex w-full items-center justify-between px-3 py-2"
                  onClick={handleLinkClick}
                >
                  <span className="text-lg">{item}</span>
                </Link>
              </li>
            );
          })}

          {/* Contact Us Link */}
          <li
            className="w-full"
            style={{
              color: "#212529",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.color = "rgb(0, 109, 178)")
            }
            onMouseLeave={(e) => (e.currentTarget.style.color = "#212529")}
          >
            <Link
              to="/contact"
              className="inline-flex px-3 py-2"
              onClick={handleLinkClick}
            >
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

const Header = () => {
  return (
    <>
      {/* Header Top */}
      <nav
        className="relative hidden xl:block"
        style={{ color: "rgb(0, 109, 178)", backgroundColor: "#F0E6E0" }}
      >
        <div className="container flex items-center justify-between px-3 md:py-2">
          {/* Info List */}
          <ul className="hidden divide-x divide-gray text-base xl:flex xxl:text-lg">
            <li>
              <div className="flex items-center gap-2 px-3 xxl:px-4">
                <div
                  className="flex items-center justify-center rounded-full p-1"
                  style={{ color: "rgb(0, 109, 178)" }}
                >
                  <IconMailFilled size={24} />
                </div>
                <span className="flex flex-col gap-1">
                  <a href="mailto:hr@cognityinfo.com">hr@cognityinfo.com</a>
                </span>
              </div>
            </li>
            <li>
              <div className="flex items-center gap-2 px-3 xxl:px-4">
                <div
                  className="flex items-center justify-center rounded-full p-1"
                  style={{ color: "rgb(0, 109, 178)" }}
                >
                  <IconPhoneCall size={24} />
                </div>
                <span className="flex flex-col gap-1">
                  <a href="tel:+91 00000-00000">+91 00000-00000</a>
                </span>
              </div>
            </li>
            {/* <li>
              <div className="flex items-center gap-2 px-3 xxl:px-4">
                <div
                  className="flex items-center justify-center rounded-full p-1"
                  style={{ color: "rgb(0, 109, 178)" }}
                >
                  <IconMapPin size={24} />
                </div>
                <span className="flex flex-col gap-1">
                  <span>5th Floor, Wing-A, Statesman House, Barakhamba Road, New Delhi - 110001</span>
                </span>
              </div>
            </li> */}
          </ul>

          <div className="flex divide-x divide-gray">
            <div className="flex items-center gap-3 px-3">
              <div
                className="flex items-center justify-center rounded-full p-1"
                style={{ color: "rgb(0, 109, 178)" }}
              >
                <IconClockFilled size={24} />
              </div>
              <span>08:00am-6:00pm</span>
            </div>

            {/* Social Icons */}
            <ul className="flex gap-2">
              {[
                IconBrandFacebook,
                IconBrandTwitter,
                IconBrandInstagram,
                IconBrandLinkedin,
              ].map((Icon, index) => (
                <li key={index}>
                  <a
                    aria-label="social link"
                    href="#"
                    className="inline-flex rounded-full p-1 text-primary duration-300 hover:bg-primary hover:text-n8"
                  >
                    <div
                      className="flex items-center justify-center rounded-full p-1"
                      style={{ color: "rgb(0, 109, 178)" }}
                    >
                      <Icon size={24} />
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>

      {/* Desktop Navigation */}
      <div className="sticky top-0 z-30 hidden bg-n8 py-2.5 shadow-xl xl:block">
        <div className="container flex items-center justify-between">
          <Link to="/">
            <img
              width="171"
              height="46"
              src="/assets/shahid.png"
              alt="logo"
            />
          </Link>
          <div className="hidden items-center gap-1 xl:flex">
            <ul
              className="relative flex gap-0.5"
              style={{ marginRight: "-52px" }}
            >
              <li
                className="group relative cursor-pointer px-4 py-2.5"
                style={{ transition: "color 0.3s ease" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = "rgb(0, 109, 178)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.color = "")}
              >
                <span className="flex items-center">
                  <Link className="font-medium" to="/">
                    Home
                  </Link>
                </span>
              </li>
              <li
                className="group relative cursor-pointer px-4 py-2.5"
                style={{ transition: "color 0.3s ease" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = "rgb(0, 109, 178)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.color = "")}
              >
                <span className="flex items-center">
                  <Link className="font-medium" to="/about-us">
                    About Us
                  </Link>
                </span>
              </li>
              <li
                className="group relative cursor-pointer px-4 py-2.5"
                style={{ transition: "color 0.3s ease" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = "rgb(0, 109, 178)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.color = "")}
              >
                <span className="flex items-center">
                  <Link className="font-medium" to="/solutions">
                    Solutions
                  </Link>
                </span>
              </li>
              <li
                className="group relative cursor-pointer px-4 py-2.5"
                style={{ transition: "color 0.3s ease" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = "rgb(0, 109, 178)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.color = "")}
              >
                <span className="flex items-center">
                  <Link className="font-medium" to="/technologies">
                    Technologies
                  </Link>
                </span>
              </li>
              <li
                className="group relative cursor-pointer px-4 py-2.5"
                style={{ transition: "color 0.3s ease" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = "rgb(0, 109, 178)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.color = "")}
              >
                <span className="flex items-center">
                  <Link className="font-medium" to="/industries">
                    Industries
                  </Link>
                </span>
              </li>
              <li
                className="group relative cursor-pointer px-4 py-2.5"
                style={{ transition: "color 0.3s ease" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = "rgb(0, 109, 178)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.color = "")}
              >
                <span className="flex items-center">
                  <Link className="font-medium" to="/careers">
                    Careers
                  </Link>
                </span>
              </li>
              <li
                className="group relative cursor-pointer px-4 py-2.5"
                style={{ transition: "color 0.3s ease" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = "rgb(0, 109, 178)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.color = "")}
              >
                <Link className="font-medium" to="/contact">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div
          id="searchBar"
          className="absolute left-0 right-0 top-0 z-30 w-full -translate-y-[200%] bg-n8 py-5 shadow-lg duration-500 xl:py-9"
        >
          <div className="container">
            <form className="mx-auto flex max-w-[80%] flex-wrap items-center justify-between gap-4 md:flex-nowrap md:gap-6 xxl:max-w-full">
              <div className="flex grow items-center gap-2 rounded-[30px] border border-n6 bg-light px-7 py-3">
                <i className="ti ti-search text-n4"></i>
                <input
                  type="text"
                  className="w-full bg-transparent focus:outline-none"
                  placeholder="Write something to search...."
                />
              </div>
              <button className="btn-primary shrink-0">Search</button>
            </form>
            <span
              className="nav-bar-search-btn-close absolute right-8 top-[40%] h-full cursor-pointer"
              id="closeSearchBtn"
            >
              <i className="ti ti-x"></i>
            </span>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <MobileMenu />
    </>
  );
};

export default Header;
